import React from 'react';

import { CourseSearchProps } from 'Components/Search/Course';
import colors from 'Theme/lightTheme/colors';

import {
    CopyContainer,
    Container,
    DecorativeLinesLong,
    DecorativeLinesShortVertical,
    Heading,
    StyledCourseSearch,
    SearchWrapper
} from './CourseSearch.styled';

export interface Props {
    heading: string;
    text: string;
    search: CourseSearchProps;
    headingType?: 'h2' | 'h3';
    decoration?: 'option1' | 'option2';
    journeyCourseSearch?: boolean;
}

const CourseSearch: React.FC<Props> = ({
    heading,
    headingType = 'h3',
    text,
    search,
    decoration = 'option1',
    journeyCourseSearch = true
}) => {
    return (
        <Container $decoration={decoration} $journeyCourseSearch={journeyCourseSearch}>
            <DecorativeLinesLong $decoration={decoration} />
            <DecorativeLinesShortVertical $decoration={decoration} />
            <CopyContainer $journeyCourseSearch={journeyCourseSearch}>
                <Heading as={headingType} $decoration={decoration}>
                    {heading}
                </Heading>
                <p>{text}</p>
            </CopyContainer>
            <SearchWrapper $journeyCourseSearch={journeyCourseSearch}>
                <StyledCourseSearch
                    themeColor={{ backgroundColor: colors.campaigns.clearing.primary.hex }}
                    {...search}
                />
            </SearchWrapper>
        </Container>
    );
};

export default CourseSearch;
